import { useState } from "react";
import { CardDeck, Col, Container, Row } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

import AuctionCard from "../auctionCard";

import CATEGORIES from "../../assets/Categories";
import FLAGS from "../../assets/Flags";

import "./viewerStyles.css";

const Viewer = ({ NFTs, background = false }) => {
  const [NFTIndex, setNFTIndex] = useState(0);

  const onPressPrevious = () =>
    NFTIndex - 1 >= 0
      ? setNFTIndex(NFTIndex - 1)
      : setNFTIndex(NFTs.length - 1);

  const onPressNext = () =>
    NFTIndex < NFTs.length - 1 ? setNFTIndex(NFTIndex + 1) : setNFTIndex(0);

  const existsPrevious = NFTIndex - 1 >= 0;
  const existsNext = NFTIndex + 1 < NFTs.length;

  return (
    <Container
      className={`${
        background
          ? "viewer-container-background"
          : "viewer-container-no-background"
      }`}
    >
      {/* <Row className="justify-content-center mx-auto">
        <h2 className="viewer-title">NFT Properties</h2>
      </Row> */}
      <Row className="viewer-row mx-auto d-none d-md-flex">
        <CardDeck className="viewer-deck justify-content-center">
          {NFTs.map((NFT, index) => (
            <AuctionCard
              key={index}
              id={NFT._id}
              tokenId={NFT.tokenId}
              video={NFT.assetUrl}
              name={NFT.name}
              category={CATEGORIES(NFT.category.toLowerCase())}
              country={FLAGS(NFT.countryCode.toLowerCase())}
              countryCode={NFT.countryCode}
              point={NFT.point}
              tier={NFT.tier}
              state={NFT.state}
              owner={NFT.owner}
              startDate={NFT.startDate}
              expirationDate={NFT.expirationDate}
              bestBid={NFT.bestBid}
              bids={NFT.bids}
              initialValue={NFT.initialValue}
              currentValue={NFT.currentValue}
              userHasBids={NFT.userHasBids}
              auctioneerState={NFT.auctioneerState}
            />
          ))}
        </CardDeck>
      </Row>
      <Row className="align-items-center d-flex d-md-none">
        <Col xs={1} className="p-0 text-right">
          {existsPrevious && (
            <FontAwesomeIcon
              icon={faChevronLeft}
              size="2x"
              onClick={onPressPrevious}
              className="left-arrow"
            />
          )}
        </Col>
        <Col xs={10}>
          <AuctionCard
            id={NFTs[NFTIndex].id}
            tokenId={NFTs[NFTIndex].tokenId}
            video={NFTs[NFTIndex].video}
            name={NFTs[NFTIndex].name}
            category={CATEGORIES(NFTs[NFTIndex].category.toLowerCase())}
            country={FLAGS(NFTs[NFTIndex].countryCode.toLowerCase())}
            point={NFTs[NFTIndex].point}
            tier={NFTs[NFTIndex].tier}
            state={NFTs[NFTIndex].state}
            owner={NFTs[NFTIndex].owner}
            initialValue={NFTs[NFTIndex].initialValue}
            currentValue={NFTs[NFTIndex].currentValue}
            userHasBids={NFTs[NFTIndex].userHasBids}
            auctioneerState={NFTs[NFTIndex].auctioneerState}
          />
        </Col>
        <Col xs={1} className="p-0 text-left">
          {existsNext && (
            <FontAwesomeIcon
              icon={faChevronRight}
              size="2x"
              onClick={onPressNext}
              className="right-arrow"
            />
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Viewer;
